/* tslint:disable */
/* eslint-disable */

/**
 * 1 = PersonneInconnue
 * 2 = DegatsUsure
 * 3 = PersonneConnue
 */
export enum TypeDegatValues {
  PersonneInconnue = 1,
  DegatsUsure = 2,
  PersonneConnue = 3
}
